import { isSame } from 'src/entities/common';
import { IReservationModel } from 'src/entities/reservation';
import getStepOrder, { StepType, StepOrderType } from 'src/services/getStepOrder';

export const clearObsoleteStepValues = (
    stepType: StepType,
    orderType: StepOrderType,
    newReservation: IReservationModel,
    reservation: IReservationModel
): IReservationModel => {
    const currentStepOrder = getStepOrder(orderType);
    const stepIndex = currentStepOrder.findIndex((step) => step === stepType);

    const reservationStepType = stepType as keyof IReservationModel;
    const value = newReservation[
        reservationStepType
    ] as IReservationModel[typeof reservationStepType] & { Id: number };
    const value2 = reservation[
        reservationStepType
    ] as IReservationModel[typeof reservationStepType] & { Id: number };
    const hasValueChanged = !isSame(value, value2);

    const rules = [
        {
            stepIndex: 0,
            dependentSteps: [1, 2],
        },
        {
            stepIndex: 1,
            dependentSteps: [2],
        },
    ];

    const rule = rules.find((r) => r.stepIndex === stepIndex);

    if (hasValueChanged && rule) {
        return rule.dependentSteps.reduce(
            (acc, i) => ({ ...acc, [currentStepOrder[i]]: undefined }),
            {
                ...newReservation,
            }
        );
    }

    return { ...newReservation };
};
